import { NgModule } from '@angular/core';
import { HelpPage } from 'pages/help-page/help-page';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [HelpPage],
    imports: [PagesModule, ComponentsModule]
})
export class HelpPageModule { }
